import Entity from './entity'
export default class Order extends Entity<number>{

}